import { auth, db } from '../../firebase.js';
import { doc, getDocs, collection,getDoc } from 'firebase/firestore';
import { ProfilePage } from './ProfilePage.js';

export class ReaderProfile extends ProfilePage{
    constructor(uid){
        super(uid);
        // this.user = user;
        this.userData = null;
        this.uid = uid;
        this.role = 'reader';
        this.bookList = null;
        this.bookListLength = null;
        this.extraRoles = null;
    }
    getExtraRoles=async()=>{
      try{
        const userRef = doc(db, 'users', this.uid);
        const docSnapshot = await getDoc(userRef);
        if (docSnapshot.exists()) {
          this.extraRoles = docSnapshot.data().extraRoles;
          console.log("ExtraRoles retrieved: ",this.extraRoles );
          return this.extraRoles;
        }
        else{
          console.log("User does not exist");
        }
      }

      catch(e){
        console.log("Error retrieving extra roles: ",e);
      }
    }

    getBookLists(){
        console.log("Book lists: ",this.bookList);
        return this.bookList;
    }
    getBookListLength(){
        console.log("Book list length: ",this.bookListLength);
        return this.bookListLength;
    }

    setBookLists = async () => {
        // console.log(user.uid);
      
        try {
          const querySnapshot = await getDocs(
            collection(db, "users", this.uid, "BookLists")
          );
          const bookStacks = querySnapshot.docs.map((doc) => doc.data());
          
          console.log("BookStacks from class: ",bookStacks);
          this.bookList = bookStacks;
          this.bookListLength = bookStacks.length;
      
        } catch (error) {
          console.error("Error getting documents: ", error);
          return false;
        }
      };

      setReaderData = (data) =>{
        this.username = data.username;
        this.pronouns = data.pronouns;
        this.following = data.following;
        this.followers = data.followers;
        this.bio = data.bio;
        this.bookList = data.BookLists;
        if (this.bookList == null) this.bookListLength = 0;
        else this.bookListLength = this.bookList.length;
        this.followersCount = data.followers?.length || 0;
        this.followingCount = data.following?.length || 0;
      }
  
      
      getBookListName = (docID) =>{
  
        const keys = Object.keys(this.bookList);
        if (keys.includes(docID))
          {
            return this.bookList[docID].bookListTitle;
          }
          else {
            throw new Error('No book lists found for your account.');
          }
      }
  
      getBooksInBookList = (docID) =>{
        const keys = Object.keys(this.bookList);
        if (keys.includes(docID))
          {
            return this.bookList[docID].books;
          }
          else {
            console.log("No such document!");
          }
      }
  


    }